<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6" md="3">
        <v-select
            v-model="formulario.marca"

            label="Buscar marca"
            outlined
            clearable
            :items="getMarcas()"
          />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
            v-model="formulario.modelo"
            label="Buscar modelo"
            outlined
            clearable
            :items="getModelos()"
          />
      </v-col>
      <v-col cols="12" sm="6" md="3">

        <v-select
            v-model="formulario.tipo"
            label="Buscar tipo"
            outlined
            clearable
            :items="getTipos()"
          />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-checkbox v-model="formulario.activo" label="Activo" color="primary" />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-btn style="margin:4px" color="primary" @click="buscar">Buscar</v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="6" v-if="$auth.can(['administrador','operador']) && $auth.user().institucion.tipo === 1">
        <v-btn style="margin:4px" color="success" @click="crear">Cargar modelo en forma manual</v-btn>
        <br>
        <v-btn style="margin:4px" color="success" v-show="!interfaz.mostrar_carga_archivo"
          @click="interfaz.mostrar_carga_archivo = true">Cargar modelos a través
          de
          archivo</v-btn>
      </v-col>
    </v-row>
    <div class="d-inline-flex align-center" style="width: 100%; height: 85px">
      <div v-show="interfaz.mostrar_carga_archivo">
        <v-file-input  v-model="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv,application/vnd.oasis.opendocument.spreadsheet"
        prepend-icon="mdi-paperclip" class="mt-4" label="Seleccionar archivo" outlined show-size
        hint="Tamaño máximo: 8 MB" persistent-hint @change="analizarFile" />

        <button color="primary" outlined small @click="descargarEjemplo">
            <v-icon left> mdi-download </v-icon>
            Descargar ejemplo
          </button>
          </div>

      <div v-if="!!loading" class="flex">
        <v-progress-circular :size="20" color="primary" indeterminate width="2" />
        <span class="text-caption text--secondary ml-1"> Cargando archivo... </span>
      </div>
    </div>
    <v-alert v-if="errores.length" type="error"  dismissible border="left" color="red" class="mb-4">
      <ul>
        <li v-for="(error, index) in errores" :key="index">
          {{ error }}
        </li>
      </ul>
    </v-alert>
    <v-alert v-if="success.length" type="success"  dismissible border="left" color="red" class="mb-4">
      <ul>
        <li v-for="(error, index) in success" :key="index">
          {{ error }}
        </li>
      </ul>
    </v-alert>


    <v-data-table v-if="modelos.length > 0" 
    hide-default-footer
    :headers="[
      { text: 'Activo', value: 'activo' },
      { text: 'Marca', value: 'marca' },
      { text: 'Modelo', value: 'modelo' },
      { text: 'Tipo', value: 'tipo' },
      { text: 'Acciones', value: 'acciones' }
    ]" 
    :items="modelos" 
    :items-per-page="50"
    item-value="id" 
    class="elevation-1">
      <template v-slot:[`item.activo`]="{ item }">
        <v-icon v-if="item.activo" color="green">mdi-check-circle</v-icon>
        <v-icon v-else color="red">mdi-close-circle</v-icon>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">

        <v-menu v-if="$auth.can(['administrador','operador']) && $auth.user().institucion.tipo === 1">
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" color="grey darken-1" icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template>
              <v-list-item v-if="item.activo" :key="desactivar" @click="desactivar(item)">
                <v-list-item-title>Desactivar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!item.activo" :key="activar" @click="activar(item)">
                <v-list-item-title>Activar</v-list-item-title>
              </v-list-item>

              <v-list-item v-if="!item.activo" :key="eliminar" @click="eliminar(item)">
                <v-list-item-title>Eliminar</v-list-item-title>
              </v-list-item>

            </template>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    
    <small v-if="modelos.length > 49" class="text--secondary">
      Se muestran los primeros 50 resultados. Por favor, refine su búsqueda.
      </small>
  </div>
</template>

<script>
import InputTramite from '@/components/Input/InputTramite'
import ChipCuenta from '@/admin/components/ChipCuenta'

import { VTextField } from 'vuetify/lib/components'

export default {
  components: {
    ChipCuenta,
    InputTramite,
    VTextField
  },
  data() {
    return {
      interfaz: { mostrar_carga_archivo: false },
      formulario: {},
      modelos: [],
      loading:false,
      errores:[],
      success: [],
      todosModelos:[]

    }
  },
  computed: {

  },
  mounted() {
    this.buscarTodos()

  },
  methods: {

    getMarcas() {
      return this.todosModelos
      .map((modelo) => modelo.marca)
      .filter((marca, index, self) => self.indexOf(marca) === index)
      .sort((a, b) => a.localeCompare(b));
    
    },
    
    getModelos() {
      let modelos = this.todosModelos;
      if (this.formulario.marca) {
        modelos = modelos.filter((modelo) => modelo.marca === this.formulario.marca);
      }
      return modelos
        .map((modelo) => modelo.modelo)
        .filter((modelo, index, self) => self.indexOf(modelo) === index)
        .sort((a, b) => a.localeCompare(b));
    
    },

    getTipos()
    {
      let tipos = this.todosModelos;
      if (this.formulario.marca) {
        tipos = tipos.filter((modelo) => modelo.marca === this.formulario.marca);
      }
      if (this.formulario.modelo) {
        tipos = tipos.filter((modelo) => modelo.modelo === this.formulario.modelo);
      }
      return tipos
        .map((modelo) => modelo.tipo)
        .filter((tipo, index, self) => self.indexOf(tipo) === index)
        .sort((a, b) => a.localeCompare(b));
    },
  
    analizarFile() {
      this.errores = []
      this.success = []
      const headers = { 'Content-Type': 'multipart/form-data' }
      const formData = new FormData()
      formData.append('archivo', this.file)

      this.loading = true
      this.$axios
        .post(`bum/permisos-provisionales/modelos-vehiculos/cargarArchivo`, formData, {
          headers,
          timeout: this.sincrona ? (180 + 10) * 1000 : 30 * 1000,
        })
        .then((response) => {
          this.success=["Archivo cargado exitosamente"];
        })
        .catch((error) => {
          console.warn(error)
          this.errores=['Se produjo un error']          ;
        })
        .finally(() => {
          this.loading = false
        })
    },
    crear() {
      this.$router.push("/permisos-provisionales/modelos-vehiculos/crear")
    },
    activar(modelo) {

      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/activar/${modelo.id}`)
        .then((response) => {
          const modeloModificada = response.data.modelo
          // reemplazar en this.modelos
          this.modelos = this.modelos.map((p) => {
            if (p.id === modeloModificada.id) {
              return modeloModificada
            }
            return p
          })
        })

    },
    desactivar(modelo) {
      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/desactivar/${modelo.id}`)
        .then((response) => {
          const modeloModificada = response.data.modelo
          // reemplazar en this.modelos
          this.modelos = this.modelos.map((p) => {
            if (p.id === modeloModificada.id) {
              return modeloModificada
            }
            return p
          })
        })

    },

    buscarTodos() {
      // this.modelos =[]
      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/listTodos`)
        .then((response) => {
          this.todosModelos = response.data
        })
    },

    buscar() {
      // this.modelos =[]
      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/list`, { params: this.formulario })
        .then((response) => {
          this.modelos = response.data.data
        })
    },
    eliminar(item) {
      this.$axios
        .delete(`bum/permisos-provisionales/modelos-vehiculos/${item.id}`)
        .then((response) => {
          this.buscar()
        })
    },
    descargarEjemplo() {
  this.$axios
    .post(
      `bum/permisos-provisionales/modelos-vehiculos/descargarEjemplo`,
      {},
      { responseType: 'blob' }
    )
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ejemplo.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
},

  },
}
</script>
